import OtherDealsPopup from "@/core/other-deals-popup/other-deals-popup.vue";
import PopupDialog from "@/core/popup-dialog/popup-dialog.vue";
import ConfirmPopup from "@/core/confirm-popup/confirm-popup.vue";
import { setup, Vue } from "vue-class-component";
import { Options } from "vue-property-decorator";
import { appModel } from "./app.model";
import { routerModel } from "./router/router.model";
import AppCompanyStatusDialogComponent from "./shared/components/app-company-status-dialog/app-company-status-dialog.vue";
import { theme, brandLabel } from "./themes";

@Options({
    components: {
        OtherDealsPopup,
        PopupDialog,
        ConfirmPopup,
        "app-company-status-dialog": AppCompanyStatusDialogComponent,
    },
})
export class AppComponent extends Vue {
    model = setup(() => {
        appModel.setup();

        return appModel;
    });

    get overflowClear() {
        return !!routerModel.router?.currentRoute.value.meta.overflowClear;
    }

    private applyTheme(theme: any) {
        Object.keys(theme).forEach((key) => {
            document.documentElement.style.setProperty(`--${key}`, theme[key]);
        });
    }

    created() {
        if (!theme) {
            console.warn(`Theme not found for brand: ${brandLabel}`);
            return;
        }
        this.applyTheme({
            ...theme.colors,
            ...theme.fonts,
        });
    }
}
